//XControl.tsx
import React from 'react';
import styles from './XControl.module.scss';
import {XComponent} from './XComponent';
import {IControlProps} from './IControlProps';
import {IControlState} from './IControlState';

export class XControl<E extends HTMLElement, P extends IControlProps = {}, S extends IControlState = {}, SS = any> extends XComponent<E, P, S, SS> {
    protected className: string | undefined = styles.XControl;

    protected static defaultProps = {
        ...XComponent.defaultProps
    }
    public constructor(props: P) {
        super(props);
        this.className = styles.XControl;
    }
    public componentDidMount(): void{
        super.componentDidMount()
    }
    public componentWillUnmount(): void{
        super.componentWillUnmount();
    }
    
    public render(): React.ReactNode {
        return (<React.Fragment></React.Fragment>);
    }
}
